import {Injectable} from '@angular/core';
import {Observable, of, throwError} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';

import {PhoneVerificationReqRes} from 'src/app/shared/components/phone-verification-dialog/PhoneVerificationReqRes.model';
import {LoggerService} from 'src/app/shared/errors/logger.service';
import {SearchOptionsRequest} from 'src/app/shared/models/SearchOptionsRequest.model';
import {SearchOptionsResponse} from 'src/app/shared/models/SearchOptionsResponse.model';
import {AbstractRestService} from 'src/app/shared/types/AbstractRestService';
import {HttpService} from '../http.service';
import {PhoneVerificationReq} from '../../shared/components/phone-verification-dialog/PhoneVerificationReq.model';
import {InvestingEntityOwnershipReqRes} from '../../dashboard/models/InvestingEntityOwnershipReqRes.model';
import { UnitApplicationValidationLevel } from 'src/app/shared/models/unit-bank-account/CreateUpdateDraftUnitApplication.model';
import { UnitBusinessApplicationReqRes } from 'src/app/shared/models/unit-bank-account/UnitBusinessApplicationReqRes.model';

@Injectable()
export abstract class UnitBankApplicationDataService extends AbstractRestService<UnitBusinessApplicationReqRes, UnitBusinessApplicationReqRes> {

  abstract readonly baseEndpoint$;

  constructor(public http: HttpService) {
    super(http);
  }

  abstract getList(options: SearchOptionsRequest): Observable<SearchOptionsResponse<UnitBusinessApplicationReqRes>>;

  abstract createDraft(model: UnitBusinessApplicationReqRes, validationLevel: UnitApplicationValidationLevel):Observable<UnitBusinessApplicationReqRes>;

  abstract updateDraft(applicationId: number, model: UnitBusinessApplicationReqRes, validationLevel: UnitApplicationValidationLevel):Observable<UnitBusinessApplicationReqRes>;

  abstract sendToUnit(applicationId: number, model: UnitBusinessApplicationReqRes):Observable<UnitBusinessApplicationReqRes>;

  abstract sendVerificationCode(applicationId: number): Observable<PhoneVerificationReqRes>;

  abstract resendVerificationCode(applicationId: number): Observable<PhoneVerificationReqRes>;

  abstract verifyPhone(applicationId: number, request: PhoneVerificationReq): Observable<PhoneVerificationReqRes>;

  /** If a file was uploaded, attach it to the relevant document and sent it to Unit for review. If the file was removed, delete it from the document entity. */
  abstract updateDocument(applicationId: number, documentId: number, metaFileLinkId: number, backSideMetaFileLinkId: number,);

  /**
   * Gets investing entities with more than 25% ownership in the holding
   * @param holdingId holding id
   */
   abstract getAutoGeneratedBeneficialOwners(holdingId: number): Observable<InvestingEntityOwnershipReqRes[]>;

   abstract clientHasApprovedUnitApplication(): Observable<boolean>;

   abstract getOrganizationApplication(): Observable<UnitBusinessApplicationReqRes>;

   abstract getAvailableOrganizationLevelApplications():Observable<UnitBusinessApplicationReqRes[]>;
}
